import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from '../dashboard/Dashboard';
import Analytics from '../analytics/Analytics';
import UserManagement from '../management/UserManagement';
import CouponCodeManagement from '../management/CouponCodeManagement';
import PolicyManagement from '../management/PolicyManagement';
import PlanManagement from '../management/PlanManagement';
import SubscriptionsAndTransactions from '../management/SubscriptionsAndTransactions';
import TutorialManagement from '../management/TutorialManagement';
import Reporting from '../management/Reporting';
import OrganizationManagement from '../management/OrganizationManagement';

const navLinks = [
  { to: '/dashboard', label: 'Dashboard' },
  { to: '/analytics', label: 'Analytics' },
  { to: '/reporting', label: 'Reporting' },
  { to: '/users', label: 'User Management' },
  { to: '/organizations', label: 'Organizations' },
  { to: '/coupon-codes', label: 'Coupon Codes' },
  { to: '/policies', label: 'Policy Management' },
  { to: '/plans', label: 'Plan Management' },
  { to: '/subscriptions', label: 'Subscriptions & Transactions' },
  { to: '/tutorials', label: 'How-to / Tutorials' },
];

const AppShell = ({
  loading,
  dashboardStats,
  dashboardActivity,
  users,
  usersLoading,
  usersPagination,
  usersStatusFilter,
  usersSort,
  onUsersPageChange,
  onUsersStatusChange,
  onUsersEmailSearch,
  onUsersDateSearch,
  onUsersSortChange,
  onRefreshUsers,
  policies,
  subscriptions,
  transactions,
  onLogout,
}) => (
  <div className="app-shell py-4 py-lg-5">
    <div className="container-fluid">
      <div className="admin-surface rounded-5 shadow-lg overflow-hidden d-flex flex-column flex-lg-row">
        <aside className="sidebar p-4 p-xl-5">
          <div className="brand-block rounded-4 shadow-sm mb-5">
            <div className="brand-icon rounded-circle shadow-sm">TM</div>
            <div>
              <h4 className="mb-0 fw-semibold">ToivoTek</h4>
              <small className="text-muted">Master Control</small>
            </div>
          </div>
          <nav className="nav flex-column gap-2">
            {navLinks.map((link) => (
              <a
                key={link.to}
                href={link.to}
                className="nav-link rounded-4 shadow-sm"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </aside>

        <div className="content-area flex-grow-1 d-flex flex-column bg-white">
          <header className="topbar px-4 px-xl-5 py-4 d-flex flex-column flex-lg-row gap-3 align-items-lg-center justify-content-end">
            <div className="d-flex align-items-center gap-3">
              <div className="dropdown">
                <div className="avatar-circle shadow-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                  AD
                </div>
                <ul className="dropdown-menu dropdown-menu-end">
                  <li>
                    <button 
                      className="dropdown-item" 
                      onClick={onLogout}
                      disabled={loading}
                    >
                      Logout
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </header>
          <main className="flex-grow-1 px-4 px-xl-5 py-4 py-xl-5">
            <Routes>
              <Route
                index
                element={<Navigate to="/dashboard" replace />}
              />
              <Route
                path="/dashboard"
                element={
                  <Dashboard
                    stats={dashboardStats}
                    loading={loading}
                    users={users}
                    usersLoading={usersLoading}
                    usersPagination={usersPagination}
                    usersStatusFilter={usersStatusFilter}
                    usersSort={usersSort}
                    onUsersPageChange={onUsersPageChange}
                    onUsersStatusChange={onUsersStatusChange}
                    onUsersEmailSearch={onUsersEmailSearch}
                    onUsersDateSearch={onUsersDateSearch}
                    onUsersSortChange={onUsersSortChange}
                    onRefreshUsers={onRefreshUsers}
                  />
                }
              />
              <Route
                path="/analytics"
                element={
                  <Analytics
                    users={users}
                    usersLoading={usersLoading}
                    usersPagination={usersPagination}
                    usersStatusFilter={usersStatusFilter}
                    usersSort={usersSort}
                    onUsersPageChange={onUsersPageChange}
                    onUsersStatusChange={onUsersStatusChange}
                    onUsersEmailSearch={onUsersEmailSearch}
                    onUsersDateSearch={onUsersDateSearch}
                    onUsersSortChange={onUsersSortChange}
                    onRefreshUsers={onRefreshUsers}
                  />
                }
              />
              <Route
                path="/reporting"
                element={<Reporting />}
              />
              <Route
                path="/users"
                element={
                  <UserManagement
                    users={users}
                    loading={usersLoading}
                    pagination={usersPagination}
                    statusFilter={usersStatusFilter}
                    sortFilter={usersSort}
                    onStatusChange={onUsersStatusChange}
                    onPageChange={onUsersPageChange}
                    onSearchChange={onUsersEmailSearch}
                    onDateChange={onUsersDateSearch}
                    onSortChange={onUsersSortChange}
                    onRefreshUsers={onRefreshUsers}
                  />
                }
              />
              <Route path="/coupon-codes" element={<CouponCodeManagement />} />
              <Route
                path="/policies"
                element={<PolicyManagement policies={policies} loading={loading} />}
              />
              <Route path="/plans" element={<PlanManagement />} />
              <Route
                path="/subscriptions"
                element={
                  <SubscriptionsAndTransactions />
                }
              />
              <Route
                path="/organizations"
                element={<OrganizationManagement />}
              />
              <Route
                path="/tutorials"
                element={<TutorialManagement />}
              />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </main>
        </div>
      </div>
    </div>
  </div>
);

export default AppShell;
